import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { niceDate } from '../util/date';

import "./Home.css"

function Account (props){
    
    useEffect(() => {     
        console.log('props.account.idTokenClaims', props.account.idTokenClaims)
    }, []); 

    return (        
        <div className='pt-2'>
            <h1>Account</h1>
            <div className="ag-theme-alpine" >
                environment: {props.account.environment}<br></br>
                account.localAccountId: {props.account.localAccountId}<br></br>
                sub: {props.account.idTokenClaims.sub}<br></br>
                auth_time: {new Date(props.account.idTokenClaims.auth_time * 1000).toLocaleString()}<br></br>
                oid: {props.account.idTokenClaims.oid}<br></br>
                newUser: {props.account.idTokenClaims.newUser ? 'yes' : 'no'}<br></br>
                given_name: {props.account.idTokenClaims.given_name}<br></br>
                family_name: {props.account.idTokenClaims.family_name}<br></br>
                extension_inviteCode: {props.account.idTokenClaims.extension_inviteCode}<br></br>
                tfp: {props.account.idTokenClaims.tfp}<br></br>
            </div>
        </div>                
    )
}

export default Account;